import React from "react";
import styled from "styled-components";
import { Box, Button, Card, Flex } from "rebass";

import { FileItem } from "../components/FileItem";
import { FileList as FileListBase } from "../components/FileList";
import { Entry } from "../types";

interface IProps {
  entries: Entry[],
  openFileSelection(): void;
}

const BrowseButton = styled(Button)`
  &:hover {
    background-color: ${({ theme }) => theme.colors["sp-gray1"]};
  }
`;

export const FileList: React.FC<IProps> = ({ entries, openFileSelection }) => (
  <Flex height="100%" flexDirection="column">
    <Card
      borderBottom="1px solid"
      borderBottomColor="sp-gray1"
      css="display: flex;"
    >
      <BrowseButton
        ml="auto"
        type="button"
        borderRadius="0"
        color="sp-blue"
        bg="transparent"
        onClick={openFileSelection}
      >
        browse
      </BrowseButton>
    </Card>

    <Box flex="1" css="overflow: hidden;">
      <FileListBase
        isEmpty={false}
        activeName="files"
      >
        {
          entries.map(({ id, name, type, createdTime, size }) => (
            <FileItem
              key={id}
              name={name}
              type={type}
              size={size}
              createdTime={createdTime}
              checked
            />
          ))
        }
      </FileListBase>
    </Box>
  </Flex>
);
